import { api } from 'common';

import { SendEmailBlockFormFields } from './FormFields';
import { SendEmailNodeOutputContent } from './Output/OutputContent';
import { SEND_EMAIL_BLOCK_BASE_CONTENT } from './baseContent';
import { SendEmailDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const sendEmailConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'SendEmail',
  defaultConfig: {
    senderEmail: '',
    senderName: '',
    recipientEmail: '',
    subject: 'Automated Email',
    content: SEND_EMAIL_BLOCK_BASE_CONTENT,
    timeout: {
      value: 15,
      units: api.FlowDefinition.DurationUnits.Minutes,
    },
  },
  configFields: {
    schema: api.FlowDefinition.SendEmailConfigSchema,
    FormFields: SendEmailBlockFormFields,
  },
  documentationMarkdown: SendEmailDocumentationMarkdown,
  OutputContentComponent: SendEmailNodeOutputContent,
};
